import { UsersApiService } from '@portal-front-end/api';
import { OrganisationId } from '@portal-front-end/models';
import { switchMap, filter, map, tap } from 'rxjs/operators';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadingRolesPermissions, permissionLoaded } from './roles-permissions.actions';
import { Action } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class RolesPermissionsEffects {
    loadPermissions$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(loadingRolesPermissions),
            switchMap((payload: { orgId: OrganisationId }) =>
                this.userApi.getUserPermission(payload.orgId).pipe(
                    filter((rolesPerms) => rolesPerms && rolesPerms !== undefined),
                    map((perms) => permissionLoaded({ permissions: perms }))
                )
            )
        )
    );
    constructor(private actions$: Actions, private userApi: UsersApiService) { }
}
